module.exports = __webpack_public_path__ + "6e9d641ac33be305934c58ba1ddfa39c.MP3";